import { render, staticRenderFns } from "./FolderModal.vue?vue&type=template&id=25c9d95c&"
import script from "./FolderModal.vue?vue&type=script&lang=js&"
export * from "./FolderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports